// import RootComponents from "../../components/common/RootComponents";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import styles from "./Profile.module.css";
import { customTextColor } from "../../utils/const";
import ProfileBanner from "./ProfileBanner";
import { PiUserLight } from "react-icons/pi";
import { BsGenderAmbiguous } from "react-icons/bs";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { CiLinkedin } from "react-icons/ci";
import { PiAddressBookLight } from "react-icons/pi";
import { PiChairLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { PiIdentificationCardLight } from "react-icons/pi";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowRoundBack } from "react-icons/io";
import { getProfile } from "../../redux/profile/profileSlice";

const Profile = () => {
  const [userDetails, setUserdetails] = useState({});
  const [banner, setBanner] = useState(null);
  const [profile_image, setProfile_image] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const location = useLocation();
  // const { userDetails } = location.state || {};
  const profile = useSelector((state) => state.profile);
  const profileLoading = useSelector((state) => state.profile.status);

  useEffect(() => {
    if (profile) {
      setUserdetails(profile?.data?.profile);
      setBanner(profile?.data?.profile?.banner_picture);
      setProfile_image(profile?.data?.profile?.profile_picture);
    }
  }, [profile]);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  return (
    // <RootComponents>
    <Box className={styles.profile_view_structure}>
      <ProfileBanner banner={banner} profile_image={profile_image} />
      {profileLoading === "loading" ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 230,
          }}
        >
          <CircularProgress size={30} color="info" />
        </Box>
      ) : (
        <Grid
          container
          className={styles.profile_details_view}
          sx={{ color: customTextColor }}
        >
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <span>
              <Box>
                <PiIdentificationCardLight
                  style={{ fontSize: "25px", color: customTextColor }}
                />
                <Typography>
                  User ID: <b>{userDetails?.username}</b>
                </Typography>
              </Box>

              <Box>
                <BsGenderAmbiguous
                  style={{ fontSize: "25px", color: customTextColor }}
                />
                <Typography>
                  Gender: <b>{userDetails?.gender}</b>
                </Typography>
              </Box>

              <Box>
                <PiAddressBookLight
                  style={{ fontSize: "25px", color: customTextColor }}
                />
                <Typography>
                  Experience:{" "}
                  <b>
                    {userDetails?.experience}{" "}
                    {userDetails?.experience > 1 ? "Years" : "Year"}
                  </b>
                </Typography>
              </Box>

              <Box>
                <PiMailboxLight
                  style={{ fontSize: "25px", color: customTextColor }}
                />
                <Typography>
                  Work Email ID: <b>{userDetails?.email}</b>
                </Typography>
              </Box>
              <Box>
                <PiBuildingOfficeLight
                  style={{ fontSize: "25px", color: customTextColor }}
                />
                <Typography>
                  Company Website: <b>{userDetails?.company_website}</b>
                </Typography>
              </Box>
            </span>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6}>
            <span>
              <Box>
                <PiUserLight
                  style={{ fontSize: "25px", color: customTextColor }}
                />
                <Typography>
                  Name: <b>{userDetails?.full_name}</b>
                </Typography>
              </Box>

              <Box>
                <PiChairLight
                  style={{ fontSize: "25px", color: customTextColor }}
                />
                <Typography>
                  Designation: <b>{userDetails?.designation}</b>
                </Typography>
              </Box>

              <Box>
                <CiMobile3
                  style={{ fontSize: "25px", color: customTextColor }}
                />
                <Typography>
                  Work Phone No: <b>{userDetails?.mobile_no}</b>
                </Typography>
              </Box>
              <Box>
                <PiBuildingOfficeLight
                  style={{ fontSize: "25px", color: customTextColor }}
                />
                <Typography>
                  Company: <b>{userDetails?.company_name}</b>
                </Typography>
              </Box>
              <Box>
                <CiLinkedin
                  style={{ fontSize: "25px", color: customTextColor }}
                />
                <Typography>
                  LinkedIn URL: <b>{userDetails?.linkedin_profile_url}</b>
                </Typography>
              </Box>
            </span>
          </Grid>
        </Grid>
      )}
      {profileLoading !== "loading" && (
        <Box className={styles.profile_edit_btns}>
          <button
            onClick={() => navigate(-1)}
            style={{
              border: "1.5px solid #4285f4",
              marginRight: "10px",
              padding: "4.5px 10px ",
            }}
          >
            <IoIosArrowRoundBack style={{ fontSize: "25px", color: "#fff" }} />
          </button>
          <button
            onClick={() => {
              navigate("/profile-save");

              localStorage.setItem(
                "pofileViewData",
                JSON.stringify({ userDetails, type: "profile" })
              );
            }}
          >
            Update Profile
          </button>
        </Box>
      )}
    </Box>
    // </RootComponents>
  );
};

export default Profile;
